import { enTranslation } from "./en";
import { jaTranslation } from "./ja";

export const supportedLanguages = ["ja", "en"] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number];

export const defaultLanguage: SupportedLanguage = "ja";

export const languageStorageKey = "virtualStandardAiMeasureLanguage";

export const resources = {
  ja: {
    translation: jaTranslation,
  },
  en: {
    translation: enTranslation,
  },
} as const;
